import React from "react"
import { Route, Redirect } from 'react-router-dom';

import SimpleRoute from './simpeRoute';

import { authService, routingService } from '../../services/imports';
import { defaults } from '../../models/imports';

// Route available only while the user is NOT an active (verified) user;
// otherwise redirects to the dashboard. Cross-tab session changes are
// handled by authService (reload).
export default class ActiveRoute extends SimpleRoute {
    constructor(props) {
        super(props);
    }

    render() {
        let { redirectPath, ...props } = this.props;

        return (
            !authService.isActive() ?
                (<Route {...this.getInjectedProps()} />) :
                (<Redirect to={routingService.routePath(redirectPath || defaults.authRoute)} />)
        );
    }
}
